var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dialogInboundCalls)?_c('CommonCreateInboundCallsModal',{attrs:{"dialog":_vm.dialogInboundCalls,"createCliente":true},on:{"closeModal":function($event){_vm.dialogInboundCalls = false},"success":function($event){_vm.dialogInboundCalls = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }